import { useState } from "react";
import Modal from "components/modal";
import { toast } from "react-toastify";
import { ScaleLoader } from "react-spinners";
import useModal from "utils/hooks/use-modal";
import { cancelSubscription } from "api/stripe";
import ShimmerLoader from "components/shimmer-loader";
import { getSubscriptionData } from "api/subscriptions";
import getFormattedDate from "utils/methods/getFormattedDate";
import { useMutation, useQuery, useQueryClient } from "react-query";
import ConfirmCancelSubscription from "sections/modal/confirm-cancel-subscription";

const PlanAndBilling = () => {
  const queryClient = useQueryClient();
  const { isOpen, toggleModal, closeModal } = useModal();

  const [loading, setLoading] = useState(false);

  const {
    data: subscriptionData,
    isLoading: subscriptionLoading,
  } = useQuery("userSubscription", getSubscriptionData, {
    enabled: false,
  });

  const cancelSubscriptionMutation = useMutation(cancelSubscription, {
    onSuccess: () => {
      toast.success("Subscription cancelled");
      queryClient.refetchQueries("userSubscription");
    },
    onError: () => {
      toast.error("Failed cancelling subscription");
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const handleCancelSubscription = () => {
    setLoading(true);
    cancelSubscriptionMutation.mutate();
    closeModal();
  };

  return (
    <div className="mt-11 xl:max-w-[850px]">
      {subscriptionLoading && (
        <ShimmerLoader className="h-[54px] w-56 rounded-ns overflow-hidden" />
      )}

      {!subscriptionLoading &&
        subscriptionData &&
        !subscriptionData.canceledAt &&
        (subscriptionData.status === "active" ||
          subscriptionData.status === "trialing") && (
          <button
            disabled={loading}
            onClick={toggleModal}
            className="bg-white border border-solid border-ink rounded-ns py-2 px-[18px] shadow-pop hover:shadow-2xltext-base relative"
          >
            <span className={loading ? "opacity-0" : "opacity-100"}>
              Cancel Subscription
            </span>
            {loading && (
              <ScaleLoader
                loading={loading}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              />
            )}
          </button>
        )}

      {!subscriptionLoading && subscriptionData === null && (
        <div className="h-[42px] flex items-start">
          <p className="text-base">You have no active subscription</p>
        </div>
      )}

      {!subscriptionLoading &&
        subscriptionData &&
        subscriptionData.canceledAt && (
          <div className="h-[42px] pl-2 flex items-start">
            <p className="text-base">
              Your current plan ends on{" "}
              <strong>{getFormattedDate(subscriptionData.endDate)}</strong>
            </p>
          </div>
        )}

      {isOpen && (
        <Modal isOpen={isOpen} closeModal={closeModal}>
          <ConfirmCancelSubscription
            handleCancel={closeModal}
            handleCancelSubscription={handleCancelSubscription}
          />
        </Modal>
      )}
    </div>
  );
};

export default PlanAndBilling;